import * as types from './mutations-type'

const mutations = {
    [types.DISPLAY_DASHBOARD](state, payload) {
        state.display_dashboard = payload
    },[types.DISPLAY_SPACY](state, payload) {
        state.display_spacy = payload
    },[types.DISPLAY_DEDUPLICATES](state, payload) {
        state.display_spacy = payload
    }
}

export default mutations
